module.exports = __webpack_public_path__ + "img/painpoint2.ce678568.png";